<cac-dialog-layout
  [title]="data.brand ? 'Edit Brand' : 'Add New Brand'"
  subtitle="Enter the required data and save"
  [form]="form"
  (onSubmit)="onSubmit($event)"
>
  <div class="flex items-center gap-x-8 p-8">
    <div class="w-44 flex-shrink-0">
      <cac-image-uploader
        [control]="form.controls.logo"
        class="h-44"
      />
    </div>
    <div class="flex flex-col gap-y-2 w-96">
      <cac-field [control]="form.controls.englishName" label="English Name" />
      <cac-field [control]="form.controls.arabicName" label="Arabic Name" />
    </div>
  </div>
</cac-dialog-layout>
